export const iconFontAwesomeMarketingFerry = (
	<i className="fa-solid fa-ferry"></i>
);
